
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import './main.css'
import '../src/assets/css/font.css'
import cookie from 'vue-cookie'
import { postAction, getAction } from '@/api/manage.js'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import MintUI, { Swipe, SwipeItem } from 'mint-ui'
import 'mint-ui/lib/style.css'
import Storage from 'vue-ls'
import moment from 'moment'
import * as VueGoogleMaps from 'vue2-google-maps'
import {mac} from './utils/util.js'
import Directives from './pages/components/directives'
getSixParams()
// 2.2.15 haoyuanw 新增PRE变量，此处统一定义管理供全局使用
//  为了测试，目前不是pre.shopvidi.com就显示，上到预发的时候这个地方要 调换一下
Vue.prototype.isPre = (window.location.origin.indexOf('pre.shopvidi.com') > -1)
                      ||(window.location.origin.indexOf('www-test.shopvidi.com') > -1)
                      ||(window.location.origin.indexOf('test-thalesmart-manage-ui2.hupofintech.com') > -1)
                      ||(window.location.origin.indexOf('localhost') > -1)
Vue.use(Directives)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCn2jsrZGPsmJ_k1gMGw_xGEX1r__7EchQ',
    libraries: 'places',
    language: 'en'
  }
})
// 全局过滤器实现日期格式化
Vue.filter('datefmt', function (input, fmtstring) { // 当input为时间戳时，需转为Number类型
  // 使用momentjs这个日期格式化类库实现日期的格式化功能
  return moment(input).format(fmtstring)
})

const starage_options = {
  namespace: 'pro__', // key键前缀
  name: 'ls', // 命名Vue变量.[ls]或this.[$ls],
  storage: 'local' // 存储名称: session, local, memory
}
Vue.use(Storage, starage_options)

export const isMobile = (/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i).test(navigator.userAgent)
export const isWechat = (/micromessenger/i).test(navigator.userAgent)
export const isIphone = (/iPhone/i).test(navigator.userAgent)
export const isAndroid = (/android/i).test(navigator.userAgent.toLowerCase())
Vue.prototype.IS_MOBILE = isMobile

Vue.prototype.$cookie = cookie

Vue.use(ElementUI, { locale })
/* let login = cookie.get('token') != null && cookie.get('token') != 'null' && cookie.get('token') != 'undefined'
console.log(login)
console.log(cookie.get('token')) */
let login = Vue.ls.get('token') != null && Vue.ls.get('token') != 'null' && Vue.ls.get(Vue.ls) != 'undefined'
console.log(login, Vue.ls.get('token'))
localStorage.setItem('mac', mac())
Vue.prototype.login = getUrlVars()['dcode'] ? false : (login || getUrlVars()['token'])
Vue.prototype.$http = axios
Vue.use(MintUI)
Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)
// Vue.directive('title', {
//   inserted: (el, binding) => {
//     document.title = binding.value
//   }
// })
var location = ''
var dsn = ''
// 判断环境
if (window.location.origin.indexOf('manage-ui') > -1) {
  // 测试环境
  location = 'https://test-thalesmart-manage-ui2.hupofintech.com'
  dsn = 'https://84aae0b9b9d6489db29f2df40240a5f2@o991616.ingest.sentry.io/5948653'
} else if (window.location.origin.indexOf('shopvidi') > -1) {
  // 生产环境
  location = 'https://shopvidi.com'
  dsn = 'https://bdf9c35881cc44fa86f1fd3abb7a9c9c@o991616.ingest.sentry.io/5948654'
}
Sentry.init({
  Vue,
  dsn: dsn,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: [location, /^\//]
    })
  ],
  trackComponents: true,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
})
var _hsq = window._hsq = window._hsq || []

if (login) {
  let userInfo = JSON.parse(localStorage.getItem('pro__userInfo'))
  Vue.prototype.userInfoObject = userInfo.value
  _hsq.push(['identify', {
    email: userInfo.email,
    id: userInfo.id
  }])
  let phone = ''
  // 处理手机号
  if (userInfo.value.phone) {
    const lastNumber = userInfo.value.phone.indexOf('-')
    if (lastNumber > -1) {
      const phoneArray = userInfo.value.phone.split('-')
      const beginNumber = userInfo.value.phone.indexOf('(')
      const prefix = userInfo.value.phone.substring(0, beginNumber)
      phone = prefix + phoneArray[1]
    } else {
      phone = userInfo.value.phone
    }
  }
  // eslint-disable-next-line no-undef
  mixpanel.identify(userInfo.value.id)
  heap.identify(userInfo.value.email)
  klaviyo.push(['identify', {
    '$email': userInfo.value.email,
    '$first_name': userInfo.value.firstName,
    '$last_name': userInfo.value.lastName,
    '$phone_number': userInfo.value.phone
  }])
  // eslint-disable-next-line no-undef
  mixpanel.people.set({ $email: userInfo.value.email, $name: userInfo.value.firstName + '-' + userInfo.value.lastName })

  // TODO haoyuanw add 2021-12-14 获取facebook信息 start
  fetch('https://api64.ipify.org/?format=json')
    .then(response => response.json())
    .then(response => {
      let deviceType = navigator.userAgent // 获取userAgent信息
      const params = {}
      params.userId = userInfo.value.id
      params.clientIpAddress = response.ip
      params.clientUserAgent = deviceType
      params.fbc = document.cookie.replace(/(?:(?:^|.*;\s*)_fbc\s*\=\s*([^;]*).*$)|^.*$/, '$1')
      params.fbp = document.cookie.replace(/(?:(?:^|.*;\s*)_fbp\s*\=\s*([^;]*).*$)|^.*$/, '$1')
      postAction('/facebook/client', params)
    })
} else {
  _hsq.push(['identify', {
    id: localStorage.getItem('mac')
  }])
  // 非登录或者非注册的情况下
  if (localStorage.getItem('utm_id') && localStorage.getItem('utm_term')) {
    const params = {}
    params.klaviyoId = localStorage.getItem('utm_id')
    params.externalId = decodeURIComponent(localStorage.getItem('utm_term'))
    postAction('/klaviyo/user/data', params).then(response => {
      if (response.success) {
        if (response.result) {
          klaviyo.push(['identify', {
            '$email': response.result.email,
            '$first_name': response.result.firstName,
            '$last_name': response.result.lastName,
            '$phone_number': response.result.phone
          }])
        }
      } else {
        this.$message.warning(response.message)
      }
    })
  }
}

Vue.config.productionTip = false
Vue.prototype.$tokenUrl = tokenUrl
Vue.prototype.$getUrlVars = getUrlVars
function tokenUrl(url, status) {
  let _url = url
  if (login) {
    _url += status ? `?token=${Vue.ls.get('token')}` : `&token=${Vue.ls.get('token')}`
  }
  return _url
}

let show = getUrlVars()['showlogin']
localStorage.setItem('show', show)

Vue.prototype.login = getUrlVars()['dcode'] ? false : (login || getUrlVars()['token'])
Vue.prototype.$http = axios
Vue.config.productionTip = false

if (process.env.NODE_ENV === 'development') {
  require('./mock')
}

function getUrlVars() {
  var vars = {}
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    vars[key] = value.split('#')[0]
  })
  return vars
}

function getEnvUrl() {
  let href = window.location.href
  let url = window.location.host
  if (href.indexOf('test') >= 0) {
    url = 'https://test-thalesmart-manage-ui.hupofintech.com'
    return url
  }
  if (href.indexOf('localhost') >= 0) {
    url = 'http://localhost:3000'
    return url
  }
  if (href.indexOf('shopvidi') >= 0) {
    url = 'https://p.shopvidi.com'
    return url
  }
}

// add by cpgu 2021/10/16 begin
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
// end by cpgu
// add by haoyuanw 2022/04/27 begin
router.beforeEach((to, from, next) => {
  // 2.0.6 增加进入到路由跳转就 给klaviyo传数据
  klaviyo.push(['track', 'Active on Site', {url: window.location.origin + to.path}])
  _hsq.push(['setPath', to.fullPath])
  _hsq.push(['trackPageView'])
  if (Vue.ls.get('token')) {
    getAction('/register/replenish').then((response) => {
      if (response.success) {
        if (!response.result) {
          router.push('/profile')
        }
      }
    })
  }
  if (to.name == 'brand' || to.name == 'category' || to.name == 'collection') {
    postAction('/ts/tdks/router/' + to.name, to.params)
      .then((res) => {
        if (res.success) {
          if (res.result) {
            document.title = res.result.title
            const head = document.getElementsByTagName('head')
            const meta = document.createElement('meta')
            document.querySelector('meta[name="keywords"]').setAttribute('content', res.result.keywords)
            document.querySelector('meta[name="description"]').setAttribute('content', res.result.description)
            const metaContent = {}
            metaContent.keywords = res.result.keywords
            metaContent.description = res.result.description
            meta.content = metaContent
            head[0].appendChild(meta)
          }
          next()
        } else {
          this.$message.warning(res.message)
        }
      }).catch(() => {
        next()
      })
  } else if (to.name === 'Home') {
    document.title = 'ShopVidi - Unique wholesale marketplace with trusted brands'
    let description = 'ShopVidi | All-in-one shop for thousands of unique products with great buys from worldwide. Shop smarter with better price | Free net 60 term | Low minimum spend.'
    let keywords = 'ShopVidi | Purchasing and Wholesale Platform|Physical Retail and Wholesale Market'
    const head = document.getElementsByTagName('head')
    const meta = document.createElement('meta')
    document.querySelector('meta[name="keywords"]').setAttribute('content', keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', description)
    const metaContent = {}
    metaContent.keywords = keywords
    metaContent.description = description
    meta.content = metaContent
    head[0].appendChild(meta)
    next()
  } else if (to.name === 'vi local') {
    document.title = ''
    next()
  } else {
    document.title = to.name
    next()
  }
})
// router.beforeEach((to, from, next) => {
//   console.log(to.params,to,"当前路由守卫")
//   let params = to.path
//   if (params !== '' && params !== null && params !== undefined) {

//   }
//    路由发生变化改变description和keyword

// const head = document.getElementsByTagName('head')
// const meta = document.createElement('meta')
// document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
// document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
// meta.content = to.meta.content
// head[0].appendChild(meta)

// 路由发生变化修改页面title

//   next()
// })

function getRoutesList(routes, pre) {
  return routes.reduce((array, route) => {
    const path = `${pre}${route.path}`

    if (route.path !== '*') {
      array.push(path)
    }

    if (route.children) {
      array.push(...getRoutesList(route.children, `${path}/`))
    }

    return array
  }, [])
}

function getRoutesXML() {
  const list = getRoutesList(router.options.routes, 'https://www.shopvidi.com')
    .map(route => `<url><loc>${route}</loc></url>`)
    .join('\r\n')
  return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
    ${list}
  </urlset>`
}
console.log(getRoutesXML(), 'router路由结果')

// add by haoyuanw 2022/04/27 end

// haoyuanw add 2021-10-21 begin

function getSixParams() {
  if (!window.location.search.includes('?')) {
    return
  }
  // notes 以下数据必须存localstorage里面
  const utmSource = getParam('utm_source')
  const utmMedium = getParam('utm_medium')
  const utmCampaign = getParam('utm_campaign')
  const utmId = getParam('utm_id')
  const utmTerm = getParam('utm_term')
  const utmContent = getParam('utm_content')
  var Days = 365
  var exp = new Date()
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
  if (utmSource !== null) {
    localStorage.setItem('utm_source', utmSource)
  }
  if (utmMedium !== null) {
    localStorage.setItem('utm_medium', utmMedium)
  }
  if (utmCampaign !== null) {
    localStorage.setItem('utm_campaign', utmCampaign)
  }
  if (utmId !== null) {
    localStorage.setItem('utm_id', utmId)
  }
  if (utmTerm !== null) {
    localStorage.setItem('utm_term', utmTerm)
  }
  if (utmContent !== null) {
    localStorage.setItem('utm_content', utmContent)
  }
}
function getParam(name, search) {
  search = search || window.location.search.substr(1) || window.location.search.split('?')[1]
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  let r = search.match(reg)
  if (r != null) return decodeURI(r[2]); return null
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js